export const GET_SEED = 'GET_SEED';
export const GET_ALL_SEEDS = 'GET_ALL_SEEDS';
export const CREATE_SEED = 'CREATE_SEED';
export const SEED_LOADING = 'SEED_LOADING';

// The workspace `state.seed` is being asked about has changed. Carries only
// the id, and exists so the store can stop describing the PREVIOUS workspace
// the instant a different one is requested — see the reducer case.
export const SEED_SCOPE_CHANGED = 'SEED_SCOPE_CHANGED';
export const SEED_SUCCESS = 'SEED_SUCCESS';
export const SEED_ERROR = 'SEED_ERROR';
export const GET_CATEGORY = 'GET_CATEGORY';
export const GET_USER_SEEDS = 'GET_USER_SEEDS';
export const GET_INCOME = 'GET_INCOME';
export const GET_INCOME_LOADING = 'GET_INCOME_LOADING';
export const GET_INCOME_ERROR = 'GET_INCOME_ERROR';
export const GET_ACTION = 'GET_ACTION';
export const GET_EXPENSE = 'GET_EXPENSE';
export const GET_COMMENT = 'GET_COMMENT';
export const GET_TEAM = 'GET_TEAM';
export const CREATE_INCOME = 'CREATE_INCOME';
export const CREATE_ACTION = 'CREATE_ACTION';
export const CREATE_EXPENSE = 'CREATE_EXPENSE';
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const CREATE_TEAM = 'CREATE_TEAM';
export const CREATE_TEAM_LOADING = 'CREATE_TEAM_LOADING';
export const CREATE_TEAM_ERROR = 'CREATE_TEAM_ERROR';
export const UPDATE_SEED_TEAMS = 'UPDATE_SEED_TEAMS';
export const UPDATE_SEED_TRANSACTIONS_CATEGORIES =
  'SPDATE_SEED_TRANSACTIONS_CATEGORIES';
export const GET_INCOME_CATEGORY = 'GET_INCOME_CATEGORY';
export const GET_EXPENSE_TOTAL = 'GET_EXPENSE_TOTAL';
export const GET_INCOME_TOTAL = 'GET_INCOME_TOTAL';
// donations
export const GET_DONATIONS = 'GET_DONATIONS';
export const GET_DONATIONS_LOADING = 'GET_DONATIONS_LOADING';
export const GET_DONATIONS_ERROR = 'GET_DONATIONS_ERROR';
export const CREATE_DONATION_LOADING = 'CREATE_DONATION_LOADING';
export const CREATE_DONATION_SUCCESS = 'CREATE_DONATION_SUCCESS';
export const CREATE_DONATION_ERROR = 'CREATE_DONATION_ERROR';
//user preferences
export const GET_USER_PREFERENCES = 'GET_USER_PREFERENCES';
export const PATCH_USER_PREFENCES = 'PATCH_USER_PREFENCES';
export const PATCH_SEED_PREFENCES = 'PATCH_SEED_PREFENCES';
export const GET_SEED_PREFERENCES = 'GET_SEED_PREFERENCES';
//seed operations
export const PATCH_SEED_OPERATIONS = 'PATCH_SEED_OPERATIONS';
export const GET_SEED_OPERATIONS = 'GET_SEED_OPERATIONS';
//seed budget
export const GET_TRANSACTIONS_CATEGORIES = 'GET_TRANSACTIONS_CATEGORIES';
export const CREATE_TRANSACTIONS_CATEGORIES = 'CREATE_TRANSACTIONS_CATEGORIES';
export const CREATE_CHILD_EXPENSE = 'CREATE_CHILD_EXPENSE';
export const CREATE_CHILD_INCOME = 'CREATE_CHILD_INCOME';
export const GET_CHILD_EXPENSE = 'GET_CHILD_EXPENSE';
export const CREATE_BUDGET = 'CREATE_BUDGET';
export const CREATE_BUDGET_ESTIMATE = 'CREATE_BUDGET_ESTIMATE';
export const UPDATE_PROJECT_BUDGET_ESTIMATES =
  'UPDATE_PROJECT_BUDGET_ESTIMATES';
export const GET_BUDGET = 'GET_BUDGET';
export const GET_BUDGET_ESTIMATE = 'GET_BUDGET_ESTIMATE';
export const PATCH_BUDGET_ESTIMATE = 'PATCH_BUDGET_ESTIMATE';
export const GET_BUDGET_DASHBOARD = 'GET_BUDGET_DASHBOARD';
export const GET_BUDGET_SUMMARY = 'GET_BUDGET_SUMMARY';
export const GET_BUDGET_SUMMARY_YEAR = 'GET_BUDGET_SUMMARY_YEAR';
export const GET_BUDGET_SUMMARY_YEAR_MONTH = 'GET_BUDGET_SUMMARY_YEAR_MONTH';
export const UPDATE_BUDGET_STATUS = 'UPDATE_BUDGET_STATUS';
export const UPDATE_BUDGET = 'UPDATE_BUDGET';
export const DELETE_BUDGET = 'DELETE_BUDGET';
export const REPLACE_BUDGET_TEMP = 'REPLACE_BUDGET_TEMP';
//sponsorship
export const CREATE_CHILD = 'CREATE_CHILD';
export const CREATE_CHILD_LOADING = 'CREATE_CHILD_LOADING';
export const CREATE_CHILD_SUCCESS = 'CREATE_CHILD_SUCCESS';
export const CREATE_CHILD_ERROR = 'CREATE_CHILD_ERROR';
export const GET_CHILD = 'GET_CHILD';
export const GET_CHILDREN = 'GET_CHILDREN';
export const GET_CHILD_LOADING = 'GET_CHILD_LOADING';
export const GET_CHILD_SUCCESS = 'GET_CHILD_SUCCESS';
export const GET_CHILD_ERROR = 'GET_CHILD_ERROR';
//status updates
export const GET_STATUS_UPDATES = 'GET_STATUS_UPDATES';
export const GET_STATUS_UPDATE = 'GET_STATUS_UPDATE';
export const CREATE_STATUS_UPDATE = 'CREATE_STATUS_UPDATE';
export const GET_STATUS_UPDATE_TAGS = 'GET_STATUS_UPDATE_TAGS';
export const CHILD_STATUS_UPDATE_LOADING = 'CHILD_STATUS_UPDATE_LOADING';
export const CHILD_STATUS_UPDATE_SUCCESS = 'CHILD_STATUS_UPDATE_SUCCESS';
export const CHILD_STATUS_UPDATE_ERROR = 'CHILD_STATUS_UPDATE_ERROR';
export const EDIT_STATUS_UPDATES = 'EDIT_STATUS_UPDATES';
export const DELETE_STATUS_UPDATES = 'DELETE_STATUS_UPDATES';
//plans
export const GET_PLANS_SUCCES = 'GET_PLANS_SUCCES';
export const PLANS_LOADING = 'PLANS_LOADING';
export const GET_PLANS_ERROR = 'GET_PLANS_ERROR';
//teams
export const SEED_TEAM_ERROR = 'SEED_TEAM_ERROR';
export const GET_ALL_TEAMS = 'GET_ALL_TEAMS';
export const SEED_TEAM_LOADING = 'SEED_TEAM_LOADING';
//aggregations
export const GET_FINANCIAL_DATA = 'GET_FINANCIAL_DATA';
export const GET_FINANCIAL_DATA_LOADING = 'GET_FINANCIAL_DATA_LOADING';
export const GET_FINANCIAL_DATA_SUCCESS = 'GET_FINANCIAL_DATA_SUCCESS';
export const GET_FINANCIAL_DATA_ERROR = 'GET_FINANCIAL_DATA_ERROR';

// Contribution Means
export const GET_CONTRIBUTION_MEANS = 'GET_CONTRIBUTION_MEANS';
export const GET_CONTRIBUTION_MEANS_LOADING = 'GET_CONTRIBUTION_MEANS_LOADING';
export const GET_CONTRIBUTION_MEANS_SUCCESS = 'GET_CONTRIBUTION_MEANS_SUCCESS';
export const GET_CONTRIBUTION_MEANS_ERROR = 'GET_CONTRIBUTION_MEANS_ERROR';

// Seed banners and setup status
export const GET_BANNERS_LOADING = 'GET_BANNERS_LOADING';
export const GET_BANNERS_SUCCESS = 'GET_BANNERS_SUCCESS';
export const GET_BANNERS_ERROR = 'GET_BANNERS_ERROR';
export const DISMISS_BANNER = 'DISMISS_BANNER';
export const SET_DISMISSED_BANNERS = 'SET_DISMISSED_BANNERS';
export const GET_SETUP_STATUS_LOADING = 'GET_SETUP_STATUS_LOADING';
export const GET_SETUP_STATUS_SUCCESS = 'GET_SETUP_STATUS_SUCCESS';
export const GET_SETUP_STATUS_ERROR = 'GET_SETUP_STATUS_ERROR';
export const FOLLOW_SEED_LOADING = 'FOLLOW_SEED_LOADING';
export const FOLLOW_SEED_ERROR = 'FOLLOW_SEED_ERROR';
export const UPDATE_SEED_FOLLOW_STATE = 'UPDATE_SEED_FOLLOW_STATE';
// events
export const TEAM_EVENTS_LOADING = 'TEAM_EVENTS_LOADING';
export const TEAM_EVENTS_SUCCESS = 'TEAM_EVENTS_SUCCESS';
export const TEAM_EVENTS_ERROR = 'TEAM_EVENTS_ERROR';
export const TEAM_EVENT_SUBMITTING = 'TEAM_EVENT_SUBMITTING';
